export default "__VITE_ASSET__BlMMTFJt__"